export const validatePhoneNumber = (number: string) => {
  const phoneRegex = /^07[0-9]{8}$/;
  return phoneRegex.test(number);
};
